import { Link } from "react-router-dom"
import News2 from "../images/news2.jpg"
import SEO from './SEO';

const News = () => {
  const newsPosts = [
    {
      id: 1,
      title: "Mamata Academy of Medical Sciences Hospital Recognized for Excellence in Patient Care",
      excerpt:
         "We're proud to announce that MAMS Hospitals has received the prestigious Healthcare Excellence Award for outstanding patient care and safety standards.",
      date: "May 2, 2025",
      // author: "Dr. Malayadri",
      // category: "Hospital News",
      image: "/6c4hYqFbAaw?si=9z3L_wkralbtnXE0",
      slug: "new-cardiac-care-unit",
    },
    {
      id: 2,
      title: "A Rare Surgery Performed at Mamata Academy of Medical Sciences Hospital",
      excerpt:
        "Mamata Academy of Medical Sciences Hospital has achieved another milestone by successfully performing a rare and complex surgery, showcasing the expertise and dedication of its medical team. ",
      date: "April 28, 2025",
      // author: "Dr. Shilpa Reddy",
      // category: "Health Tips",
       image: "/FJG3x3Luye4?si=UUxs3tXnYI7UVdoy",
      slug: "understanding-diabetes-prevention-management",
    },
    {
      id: 3,
       title: "A highly complex surgery was performed on a 50-year-old patient named Ellamma ",
      excerpt:
        "Mamata Hospital has once again demonstrated its medical excellence by successfully performing a high-risk and complex surgery on a 50-year-old woman named Ellamma.",
      // author: "Admin Team",
      // category: "Awards",
     image: "/DMfXrj-iS5c?si=YuI8zMjl034LW7vU",
      slug: "recognized-for-excellence-patient-care",
    },
    {
      id: 4,
      title: "Graduation Day Celebration at Mamata Academy of Medical Sciences and Hospital",
      excerpt:
        "Mamata Academy of Medical Sciences and Hospital proudly celebrated its Graduation Day, honoring the achievements of its graduating batch of medical students. The event was filled with joy, inspiration, and pride as students received their certificates in the presence of faculty, parents, and distinguished guests. ",
      date: "April 10, 2025",
      // author: "Dr. Vidya Sagar",
      // category: "Health Tips",
      image: "/M6u3kMpQ0qQ?si=5XiOE6qFWuNY9kck",
      slug: "importance-regular-health-checkups",
    },
    {
      id: 5,
      title: " Maternity Kit Distribution to New Mothers | Celebrating Aparna Puvvada Maam’s Birthday",
      excerpt:
       "On the occasion of Aparna Puvvada Maam’s birthday, this heartfelt event features the distribution of essential maternity kits to new mothers. The video captures touching moments of gratitude, supportive community spirit, and the joy of giving back. ",
      date: "April 5, 2025",
      // category: "Hospital News",
      image: "/pBvBCGngd50?si=3S3dyEK8kVdaQ6uQ",
      slug: "new-pediatric-wing-opening",
    },

    {
      id: 6,
      title: "Mental Health Awareness: Breaking the Stigma",
      excerpt:
        "Mental health is as important as physical health. Learn about common mental health conditions, treatment options, and how to support those affected.",
      date: "March 28, 2025",
      // author: "Dr. Rahul",
      // category: "Health Tips",
      image: "/placeholder.svg?height=300&width=400",
      slug: "mental-health-awareness-breaking-stigma",
    },
  ]

  const categories = ["All", "Hospital News", "Health Tips", "Awards", "Research"]

  return (
    <>
      <SEO
        title="Blog ‒ Health Tips, News & Medical Insights | MAMS Hospitals Hyderabad"
        description="Explore the MAMS Hospitals Blog for latest health tips, medical breakthroughs, patient stories & hospital updates from Bachupally, Hyderabad. Stay informed & empowered."
        keywords="Hyderabad's Best Multispecialty Hospital, Best Hospital near Bachupally Hyderabad, Best Hospital near Miyapur Hyderabad, Best Hospital near Nizampet, Multispecialty Hospital near KPHB Colony, Emergency Hospital near JNTU Hyderabad, 24-hour Hospital in Bachupally Hyderabad, Emergency Care Hospital in Hyderabad, Best Cardiology Hospital in Hyderabad, Best Neurology Hospital Hyderabad, Orthopaedics Hospital in Bachupally Hyderabad, Best Joint Replacement Hospital Hyderabad, Spine Surgery Specialist Hyderabad, Best ENT Hospital in Hyderabad, Best Gynecology Hospital Hyderabad, Maternity & Child Care Hospital Hyderabad, Best Pediatric Hospital in Bachupally, Neonatal ICU Hospital Hyderabad, General Medicine Specialist Hyderabad, Best General Surgery Hospital Hyderabad, Critical Care Hospital near Miyapur Hyderabad, Best Physiotherapy Hospital Hyderabad, Sports Medicine Specialist Hyderabad, Urology Hospital in Hyderabad, Best Nephrology Hospital Hyderabad, Gastroenterology Specialist Hyderabad, Best Pulmonology Hospital Hyderabad, MAMS Hospitals blog, health tips Hyderabad, medical updates Bachupally, patient success stories Hyderabad, preventive health articles, expert doctor advice, wellness blog Telangana, hospital news & events Hyderabad"
        //schema={schema}
      canonicalUrl="https://mamshospitals.com/news"
      />

    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="bg-primary/5 py-12 md:py-20">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-semibold text-gray-800 mb-6">News </h1>
            <p className="text-lg text-gray-600">
              Stay updated with the latest news, health tips, and medical advancements from MAMS Hospitals.
            </p>
          </div>
        </div>
      </section>

      {/* News Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row gap-8">
            {/* Main Content */}
            <div className="md:w-4/4">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {newsPosts.map((post) => (
                  <div
                    key={post.id}
                    className="overflow-hidden border border-gray-200 hover:border-gray-300 transition-all rounded-lg bg-white shadow-sm hover:shadow-md blog-page"
                  >
                    <div className="aspect-[16/9] relative bg-gray-100">
                   
                        <iframe
                          width="100%"
                          height="100%"
                          src={`https://www.youtube-nocookie.com/embed/${post.image.split('?')[0].replace("/", "")}`}
                          title={post.title}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        />
                   
                    </div>

                    <div className="p-6">
                      {/* <div className="flex items-center gap-2 mb-2">
                        <span className="text-xs font-medium text-teal-600 bg-teal-100 px-2 py-1 rounded-full">
                          {post.category}
                        </span>
                      </div> */}
                      <div className="font-semibold text-xl mb-2 text-gray-800">
                        {post.title}
                      </div>                      
                      <p className="text-gray-600 text-sm mb-4">{post.excerpt}</p>
                      <div className="flex justify-between items-center">
                        {/* <div className="flex items-center gap-2 text-gray-500 text-xs">
                          <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                          </svg>
                          <span>{post.date}</span>
                          <span className="mx-1">•</span>
                          <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                          </svg>
                          <span>{post.author}</span>
                        </div> */}
                        {/* <Link to={`/news/${post.slug}`} className="text-teal-600 font-medium text-sm hover:underline">
                          Read more
                        </Link> */}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* {Sidebar} */}
            {/* <div className="md:w-1/4">
              <div className="sticky top-20">
                <div className="border border-gray-200 rounded-lg mb-6 bg-white p-6">
                  <h3 className="font-semibold text-lg mb-4 text-gray-800">Categories</h3>
                  <ul className="space-y-2">
                    {categories.map((category, index) => (
                      <li key={index}>
                        <Link
                          to={`/news/category/${category.toLowerCase().replace(/\s+/g, "-")}`}
                          className={`block py-2 px-3 rounded-full text-sm ${
                            category === "All" ? "bg-teal-600 text-white" : "text-gray-600 hover:bg-primary/5"
                          }`}
                        >
                          {category}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="border border-gray-200 rounded-lg bg-white p-6">
                  <h3 className="font-semibold text-lg mb-4 text-gray-800">Recent Posts</h3>
                  <ul className="space-y-4">
                    {newsPosts.slice(0, 3).map((post) => (
                      <li key={post.id} className="border-b border-gray-200 pb-4 last:border-0 last:pb-0">
                        <Link to={`/news/${post.slug}`} className="group">
                          <h4 className="font-medium text-gray-800 group-hover:text-teal-600 transition-colors">
                            {post.title}
                          </h4>
                          <p className="text-xs text-gray-500 mt-1">{post.date}</p>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div> */}
          </div>

          <div className="mt-12 text-center">
            <Link to="/">
              <div className="inline-flex items-center text-teal-800 font-medium">
                <svg className="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Back to Home
              </div>
            </Link>
          </div>
        </div>
      </section>
    </div>
    </>
  )
}

export default News
